import styled from 'styled-components';
import { Ico20 } from 'dc/Ico';

export const ActivitiesInfoIcon = styled(Ico20)`
  color: #90a4ae;
  cursor: pointer;
`;
